import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Header from "../Header";

function ThreeSixtyReviewFeedback() {
  const ratingOptions = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];
  const raterTypes = ['Manager', 'Peer', 'Subordinate', 'Customer'];
  const [reviews, setReviews] = useState([
    {
      competency: 'Leadership',
      feedback: 'Demonstrates strong decision-making skills',
      raterType: 'Manager',
      rating: 4.0,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Communication',
      feedback: 'Effectively communicates ideas in team meetings',
      raterType: 'Peer',
      rating: 3.5,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Problem Solving',
      feedback: 'Quickly identifies and resolves issues',
      raterType: 'Manager',
      rating: 4.5,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Teamwork',
      feedback: 'Collaborates well with colleagues',
      raterType: 'Peer',
      rating: 3.0,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Innovation',
      feedback: 'Brings creative solutions to challenges',
      raterType: 'Subordinate',
      rating: 4.0,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Customer Focus',
      feedback: 'Exceeds client expectations',
      raterType: 'Customer',
      rating: 4.5,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Time Management',
      feedback: 'Consistently meets deadlines',
      raterType: 'Manager',
      rating: 3.5,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Adaptability',
      feedback: 'Handles change effectively',
      raterType: 'Peer',
      rating: 3.8,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Technical Skills',
      feedback: 'Proficient in required technologies',
      raterType: 'Subordinate',
      rating: 4.2,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
    {
      competency: 'Client Relations',
      feedback: 'Builds strong client relationships',
      raterType: 'Customer',
      rating: 4.0,
      ratedEntity: 'Maxwell Mphioe',
      comment: '',
    },
  ]);

  const handleCommentChange = (index, value) => {
    console.log('handleCommentChange called for index:', index, 'value:', value);
    const updatedReviews = [...reviews];
    updatedReviews[index].comment = value;
    setReviews(updatedReviews);
  };

  const calculateRaterStats = (raterType) => {
    const filteredReviews = reviews.filter((review) => review.raterType === raterType);
    const count = filteredReviews.filter((review) => review.rating !== null).length;
    const averageRating =
      count > 0
        ? filteredReviews
            .filter((review) => review.rating !== null)
            .reduce((sum, review) => sum + review.rating, 0) / count
        : null;
    return {
      count,
      averageRating: averageRating ? parseFloat(averageRating.toFixed(1)) : null,
    };
  };

  const renderStars = (rating) => {
    if (rating === null) return 'Not Rated';
    return [...Array(5)].map((_, i) => (
      <i key={i} className={`bi ${i < rating ? 'bi-star-fill' : 'bi-star'} text-warning me-1`} />
    ));
  };

  return (
    <>
      <Header icon={"fa-solid fa-users fa-xl mx-2"} label={"Current Review Cycle / 360 Review Feedback"} />
      <main id="main" className="main">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="content-block mt-2">
                  <div className="container mt-4">
                    <div className="d-flex align-items-center mb-3 bg-tertiary p-2 text-light rounded">
                      <h3 className="mb-0">360 Review Feedback</h3>
                    </div>
                    <div className="row g-3">
                      <div className="col-lg-12">
                        <div className="card h-100">
                          <div className="card-body">
                            <h5 className="card-title">Overall Score</h5>
                            <table className="table">
                              <thead className="bg-secondary text-white">
                                <tr>
                                  <th>Rating Type</th>
                                  <th>Count</th>
                                  <th>Average Score</th>
                                  <th>Average Stars</th>
                                </tr>
                              </thead>
                              <tbody>
                                {raterTypes.map((raterType) => {
                                  const { count, averageRating } = calculateRaterStats(raterType);
                                  return (
                                    <tr key={raterType}>
                                      <td>{raterType}</td>
                                      <td>{count}</td>
                                      <td>{averageRating !== null ? `${averageRating}/5` : 'Not Rated'}</td>
<td>{renderStars(averageRating)}</td>
</tr>
);
})}
{reviews.length === 0 && (
    <tr>
        <td colSpan="4" className="text-center">No ratings available</td>
    </tr>
)}
</tbody>
</table>
</div>
</div>
</div>
</div>
<div className="mt-4">
    <table className="table table-bordere">
        <thead className="bg-tertiary text-white">
        <tr>
            <th>Competency</th>
            <th>Feedback</th>
            <th>Rater Type</th>
            <th>Rated Employee</th>
            <th>Rating</th>
            <th>Comment</th>
        </tr>
        </thead>
        <tbody>
        {reviews.length === 0 ? (
            <tr>
                <td colSpan="6" className="text-center">No Reviews added</td>
            </tr>
        ) : (
            reviews.map((review, index) => (
                <tr key={`review-${index}`}>
                    <td>
                                  <textarea
                                      className="form-control"
                                      value={review.competency}
                                      readOnly
                                      disabled
                                      rows={4}
                                  />
                    </td>
                    <td>
                                  <textarea
                                      className="form-control"
                                      value={review.feedback}
                                      readOnly
                                      disabled
                                      rows={4}
                                  />
                    </td>
                    <td>
                                  <textarea
                                      className="form-control"
                                      value={review.raterType}
                                      readOnly
                                      disabled
                                      rows={4}
                                  />
                    </td>
                    <td>
                                  <textarea
                                      className="form-control"
                                      value={review.ratedEntity}
                                      readOnly
                                      disabled
                                      rows={4}
                                  />
                    </td>
                    <td>
                        {renderStars(review.rating)}
                    </td>
                    <td>
                                  <textarea
                                      className="form-control"
                                      value={review.comment}
                                      onChange={(e) => handleCommentChange(index, e.target.value)}
                                      rows={4}
                                  />
                    </td>
                </tr>
            ))
        )}
        </tbody>
    </table>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</main>
</>
);
}

export default ThreeSixtyReviewFeedback;